import React, { useEffect, useRef } from 'react';
import { Outlet, Route, Routes, useLocation } from 'react-router';

import { ErrorBoundary } from '~/components/ErrorBoundary';
import { RouteNotFound } from '~/components/RouteNotFound';
import { UrlParamsProvider } from '~/contexts/UrlParamsContext';
import { HomePage } from '~/pages/HomePage';
import { RequestPageContainer } from '~/pages/RequestPage';
import { RequestsPage } from '~/pages/RequestsPage';
import { SearchEimPage } from '~/pages/SearchEimPage';
import {
  HomePageUrl,
  RequestCameraPageUrl,
  RequestPageUrl,
  RequestsPageUrl,
  SearchEimPageUrl,
  expandAsPath,
} from '~/pages/urls';
import { useAppDispatch } from '~/redux';
import { clearImageErrors } from '~/redux/features/imageErrorsSlice';

import { AuthWrapper } from './AuthWrapper';

const MARKET_PATH = 'market';
const REQUEST_PATH = 'requestId';
const EIM_PATH = 'eim';
const CAMERA_PATH = 'camera';

export const AppRoutes: React.FC = () => {

  const dispatch = useAppDispatch()
  const location = useLocation();
  const prevLocation = useRef<string>('');

  useEffect(() => {
    if (prevLocation.current !== location.pathname) {
      // Clear image errors on route base changes.
      dispatch(clearImageErrors());
    }
    prevLocation.current = location.pathname;
  }, [dispatch, location]);

  return (
    <Routes>
      <Route
        element={
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        }
      >
        <Route path="*" element={<RouteNotFound />} />
        <Route
          element={
            <AuthWrapper>
              <Outlet />
            </AuthWrapper>
          }
        >
          <Route path={HomePageUrl} element={<HomePage />} />
          <Route
            path={expandAsPath(RequestsPageUrl, MARKET_PATH)}
            element={<UrlParamsProvider><RequestsPage /></UrlParamsProvider>}
          />
          <Route
            path={expandAsPath(SearchEimPageUrl, MARKET_PATH, REQUEST_PATH)}
            element={<UrlParamsProvider><SearchEimPage /></UrlParamsProvider>}
          />
          <Route
            path={expandAsPath(RequestPageUrl, MARKET_PATH, REQUEST_PATH, EIM_PATH)}
            element={<UrlParamsProvider><RequestPageContainer /></UrlParamsProvider>}
          />
          <Route
            path={expandAsPath(RequestCameraPageUrl, MARKET_PATH, REQUEST_PATH, EIM_PATH, CAMERA_PATH)}
            element={<UrlParamsProvider><RequestPageContainer /></UrlParamsProvider>}
          />
        </Route>
      </Route>
    </Routes>
  );
}
